import * as React from 'react';
import { Loader } from '@symphony-ui/uitoolkit-components';
const PanelWrapper = ({ children, className, errorMessage, isLoading, ref }) => {
    const content = React.useMemo(() => {
        if (errorMessage !== undefined) {
            return (React.createElement("div", { className: 'co-error-message' }, errorMessage));
        }
        if (isLoading) {
            return (React.createElement(Loader, { className: "co-loader", type: "spinner" }));
        }
        return children;
    }, [children, errorMessage, isLoading]);
    return React.createElement("div", { className: className, ref: ref }, content);
};
export default PanelWrapper;
